import React, { Fragment } from "react";
import HeaderThemeTwo from "../HeaderThemeTwo/HeaderThemeTwo";
import FooterThemeTwo from "../FooterThemeTwo/FooterThemeTwo";

const LayoutThemeTwo = props => {
  return (
    <Fragment style={{ backgroundColor: "#F6F8FA" }}>
      <HeaderThemeTwo />
      {props.children}
      <FooterThemeTwo />
    </Fragment>
  );
};

export default LayoutThemeTwo;
